/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthenService } from './core/services/authen.service';
import { SurveyForceStoreService } from './core/services/survey-force-store.service';

@Injectable({
    providedIn: 'root',
})
export class SurveyForceApprovalInitialDataResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(
        private _authenService: AuthenService,
        private _storeService: SurveyForceStoreService,
        private _title: Title
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        this._storeService.handleAppHeight();
        this._storeService.showLoadingBar();
        return this._authenService.getApprovalInfo().pipe(
            map(({ Code = '', Data = null, State = '', Message = '' }) => {
                let error = '';
                if (Code === '200' && Data) {
                    this._title.setTitle('Survey Force - Kết quả khảo sát');
                    this._storeService.hideLoadingBar();
                    return Data;
                }
                error = Message || '';
                this._storeService.hideLoadingBar();
                this._storeService.navigateToErrorPage(error);
                return null;
            }),
            catchError((err) => {
                const errMsg = err?.error?.Message || '';
                this._storeService.navigateToErrorPage(errMsg);
                this._storeService.hideLoadingBar();
                return of(null);
            })
        );
    }
}
